import { gql } from '@apollo/client'

export const INSURANCES_QUERY = gql`
  query insurances($sortBy: InsuranceSort, $filter: InsuranceFilter, $page: Int, $limit: Int) {
    insurances(sortBy: $sortBy, filter: $filter, page: $page, limit: $limit) {
      collection {
        id
        title
        policyNumberRegex
      }
      metadata {
        totalCount
      }
    }
  }
`
